import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnlineRegistrationComponent } from './online-registration.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatTableModule } from '@angular/material/table';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FileService } from 'src/shared/services/file.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { PipeModule } from 'src/shared/pipes/pipe.module';
import { MatSelectModule } from '@angular/material/select';
import { PaymentManualLogsTableComponent } from 'src/shared/modules/payment-manual-logs-table/payment-manual-logs-table.component';
import { FeatherModule } from 'angular-feather';
import { allIcons } from 'angular-feather/icons';
import { FaIconComponent, FontAwesomeModule } from '@fortawesome/angular-fontawesome';


@NgModule({
  declarations: [OnlineRegistrationComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatRadioModule,
    MatButtonModule,
    NgxDatatableModule,
    NgxPaginationModule,
    MatTableModule,
    NgbTooltipModule,
    NgSelectModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatTabsModule,
    PipeModule,
    MatSelectModule,
    PaymentManualLogsTableComponent,
    FeatherModule.pick(allIcons),
    FontAwesomeModule,
    FaIconComponent
  ],
  exports: [
    OnlineRegistrationComponent
  ],
  providers: [
    FileService
  ]
})
export class OnlineRegistrationModule { }
